var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APVerticalScroller.css';
var scrollerClasses = getBEMClasses('ap-vertical-scroller');
var APVerticalScroller = function (_React$Component) {
  _inherits(APVerticalScroller, _React$Component);
  function APVerticalScroller(props) {
    _classCallCheck(this, APVerticalScroller);
    var _this = _possibleConstructorReturn(this, (APVerticalScroller.__proto__ || Object.getPrototypeOf(APVerticalScroller)).call(this, props));
    _this.resetUserScrolled = function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      _this.userScrolled = false;
      callback();
    };
    _this.userScrolled = false;
    _this.handleUserScrolled = function () {
      if (_this.state.isAtRest) return _this.userScrolled = false;
      _this.userScrolled = true;
    };
    _this.state = {
      isAtRest: true
    };
    _this.handleOnScroll = _this.handleOnScroll.bind(_this);
    return _this;
  }
  _createClass(APVerticalScroller, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToRest();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var descendantCount = this.getDescendantCount(this, 4);
      if (descendantCount !== this.descendantCount) {
        // handle change
        this.descendantCount = descendantCount;
        if (this.state.isAtRest) {
          this.scrollToRest();
        }
      }
      if (this.state.isAtRest) {
        this.resetUserScrolled();
      }
    }
  }, {
    key: 'getDescendantCount',
    value: function getDescendantCount(item, levels) {
      var _this2 = this;
      if (levels <= 0 || !item || !item.props || !item.props.children) return 0;
      var children = item.props.children;
      if (Array.isArray(children)) {
        if (levels > 1) {
          return children.reduce(function (acc, curr) {
            return acc + 1 + _this2.getDescendantCount(curr, levels - 1);
          }, 0);
        } else {
          return children.length;
        }
      } else {
        if (levels > 1) {
          return 1 + this.getDescendantCount(children, levels - 1);
        } else {
          return 1;
        }
      }
    }
  }, {
    key: 'handleOnScroll',
    value: function handleOnScroll(event) {
      if (!this.el) {
        return;
      }
      this.handleUserScrolled();
      var clientHeight = this.el.clientHeight;
      var scrollHeight = this.el.scrollHeight;
      var newScroll = event.currentTarget.scrollTop;
      var scrollTop = newScroll;
      var scrollBottom = scrollHeight - clientHeight - newScroll;
      var isAtRestPrev = this.state.isAtRest;
      var isAtRest = this.props.restPosition === 'top' && scrollTop <= 0 || this.props.restPosition === 'bottom' && scrollBottom <= 0;
      this.setState({
        isAtRest: isAtRest
      });
      if (isAtRestPrev !== isAtRest) {
        // call event handlers
        if (this.props.onScrollRestChange) {
          this.props.onScrollRestChange(isAtRest);
        }
      }
    }
  }, {
    key: 'getIsAtRest',
    value: function getIsAtRest() {
      return this.state.isAtRest;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(value, animate) {
      if (this.el) {
        if (animate) {
          this.scrollToAnimate(this.el, value, 200);
        } else {
          this.el.scrollTop = value;
        }
      }
    }
  }, {
    key: 'scrollToRest',
    value: function scrollToRest(animate) {
      if (!this.userScrolled || this.state.isAtRest) {
        if (this.props.restPosition !== 'bottom') {
          // default to top
          this.scrollTo(0, animate);
        } else {
          // bottom
          if (this.el) {
            this.scrollTo(this.el.scrollHeight, animate);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var _props = this.props,
        children = _props.children,
        styleName = _props.styleName,
        restPosition = _props.restPosition,
        onScrollRestChange = _props.onScrollRestChange,
        customClass = _props.customClass,
        otherProps = _objectWithoutProperties(_props, ['children', 'styleName', 'restPosition', 'onScrollRestChange', 'customClass']);
      return React.createElement('div', Object.assign({
        ref: function ref(el) {
          return _this3.el = el;
        },
        className: scrollerClasses(null, this.state.isAtRest ? 'at-rest' : null) + ' ' + customClass,
        onScroll: this.handleOnScroll
      }, otherProps), children);
    }

    // animation from https://codepen.io/rebosante/pen/eENYBv
  }, {
    key: 'scrollToAnimate',
    value: function scrollToAnimate(element, to, duration) {
      var _this4 = this;
      var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
      var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = _this4.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }

    //t = current time
    //b = start value
    //c = change in value
    //d = duration
  }, {
    key: 'easeInOutQuad',
    value: function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
  }]);
  return APVerticalScroller;
}(React.Component);
APVerticalScroller.propTypes = {
  restPosition: PropTypes.string,
  onScrollRestChange: PropTypes.func,
  customClass: PropTypes.string
};
export default APVerticalScroller;